import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"

import { LayoutContext } from "./layout-context"
import { LoadedContext } from "./loaded-context"

import Footer from "./footer"

const MotionPageContainerDiv = styled(motion.div)`
  // border: 1px solid red;
  min-height: 100vh;
  flex-direction: column;
  display: flex;
`

const MotionPageContainerInner = styled.div`
  flex: 1 0 auto;
`

const Content = styled.div`
  flex-grow: 1;
`

const PageContainer = props => {
  const loadedContext = useContext(LoadedContext)
  const layoutContext = useContext(LayoutContext)

  useEffect(() => {
    layoutContext.setLayout(props.layout)
  })

  return (
    <Content>
      {loadedContext.loaded && (
        <React.Fragment>
          <AnimatePresence exitBeforeEnter>
            <MotionPageContainerDiv
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              key={props.path}
              transition={{ duration: 0.5 }}
            >
              <MotionPageContainerInner>
                {props.children}
              </MotionPageContainerInner>
              <Footer {...props.footerOptions} layout={props.layout} />
            </MotionPageContainerDiv>
          </AnimatePresence>
        </React.Fragment>
      )}
    </Content>
  )
}

export default PageContainer
